import { render } from "./SelectIngredientModal3.vue?vue&type=template&id=360db1c6"
import script from "./SelectIngredientModal3.vue?vue&type=script&lang=js"
export * from "./SelectIngredientModal3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__